
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component, { mixins } from 'vue-class-component';
import barcodeStore from 'Store/barcode/barcodestore';
import { ScannedBarcode, ScannedBarcodeState } from 'Api/CoreApi';
import store from 'Store/store';
import barcodestore from 'Store/barcode/barcodestore';
import { xor } from 'lodash-es';
import { Prop } from 'vue-property-decorator';

import { BarcodeTableEntry, BarcodeTableEvents } from './BarcodeTableComponent';

import * as XLSX from 'xlsx';

@Component
export default class ABarcodeActionsComponent extends ABaseComponent {

    @Prop()
    public selectedState: string;

    //state avaible in the current component scope
    public availableStates: string[] = null;

    //is in state of "validated" - this is true if the response items has not changed since last validate
    protected _isValidated: boolean;

    protected triggerValidateOnTable: boolean = false;

    //error validation items
    protected errorValidate: boolean = false;

    //call is in progress - used to tell the underlying components
    protected waiting: boolean = false;

    //underlying events known to the table component
    protected tableEvents: BarcodeTableEvents = {
        add: this.addBarcode,
        remove: this.removeBarcode,
        update: this.updateBarcode
    }
    created() {
        if (!barcodeStore.barcodeList || barcodeStore.barcodeList.length == 0)
            this.addBarcode(null);
    }

    get entries(): BarcodeTableEntry[] {

        return this.barcodes.map((x: ScannedBarcode, index: number) =>
            <BarcodeTableEntry>{
                index: index,
                showDetails: true,
                value: x
            });
    }

    get barcodes(): ScannedBarcode[] {

        return barcodeStore.barcodeList;
    }

    get isEmpty(): boolean {
        return this.barcodes == null || this.barcodes.length == 0;
    }

    get canExport() {

        return this.canValidate && this._isValidated;
    }


    get canValidate() {

        return !this.barcodes.some(x => !this.barcodeIsValid(x));
    }

    get tableResync() {
        return this.waiting;
    }

    barcodeState(index: number): string {
        return this.barcodes[index].state.toString();
    }

    async addBarcode(event: Event, index: number = -1) {
        if (index > -1 && this.barcodes.length - 1 != index)
            return;
        if (this.barcodes.length == 1 && this.selectedState == 'CUSCHP')
            return;

        barcodeStore.add();

    }


    async removeBarcode(event: Event, index: number) {
        barcodeStore.remove(index);
    }

    clear() {
        barcodeStore.updateList([<ScannedBarcode>{}]);
    }
    clearList() {
        if (barcodestore) {
            barcodestore.clearList();
            barcodestore.add();
        }
    }


    barcodeIsValid(barcode: ScannedBarcode) {

        if (!barcode.number) return false;

        return !!barcode.number && barcode.number.length > 1 && !!this.selectedState; // !!barcode.state && barcode.state != 'None';
    }


    updateState(event: any, index: number, barcode: ScannedBarcode, state: string) {
        console.debug('barcode: ', barcode.number, 'change to state: ', state);
        barcodestore.clearList();
        barcode.state = state as ScannedBarcodeState;
        this.updateBarcode(event, index, barcode);
    }

    // trigger update on changed values from the v-model
    //-else the store state is not mutated to current values
    async updateBarcode(event: any, index: number, value: ScannedBarcode) {
        this.autoAdd(event, index, value);
        //if any changes - we cannot guarantee the valid state
        this._isValidated = false;

        barcodestore.updateValue({
            index: index,
            item: value
        });
    }

    autoAdd(event: any, index: number, value: ScannedBarcode) {
        if (this.barcodeIsValid(value)) {
            this.addBarcode(event, index);
        }
    }


    //export object to xlsx
    async export(caller: string, obj: any): Promise<void> {

        if (!obj) return;

        const ws = XLSX.utils.json_to_sheet(obj);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, caller);
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, `barcodes-${caller}-${Date.now()}.xlsx`);

    }

    //translate headers - ignore headers and append manuelly
    // var ws = XLSX.utils.json_to_sheet(json_data, { origin: 'A2', skipHeader: true });
    // XLSX.utils.sheet_add_aoa(ws, headings); //heading: array of arrays

    // XLSX.utils.book_append_sheet(wb, ws);


    // XLSX.writeFile(wb, filename + '.xlsx') 
}